



































































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
// import dayjs from 'dayjs';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import dayjs from 'dayjs';
import api, { apiSandbox } from '@/libs/api';
import format from '@/libs/numberFormat';
// import {
//   InvoiceResponse, Invoice, Service,
// } from '@/libs/api.interfaces';
import { MerchantsMResponse, MerchantsManagement } from '@/libs/api.interfaces';
import { AxiosError } from 'axios';
import { DateRange } from '@/components/DatePicker.vue';

interface ReportParams {
  merchant: { merchant_code: string; merchant_name: string } | null;
  month: LabelValue | null;
  year: LabelValue | null;
  status: LabelValue | null;
  service: Service | null;
  transactionDate: DateRange | null;
  brand: { merchant_brand: string } | null;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
  },
  methods: {
    format,
  },
})
export default class MerchantLeadTable extends Vue {
  loading = true;
  merchantsLead: MerchantsManagement[] = [];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  status = '';
  format!: (val: string) => string;

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  openDetail(id: string) {
    this.$router.push(`/merchant-lead/edit/${id}/information`);
  }

  dateFormat(time: string) {
    return dayjs(time).format('D MMM YYYY HH:mm');
  }

  // eslint-disable-next-line class-methods-use-this
  sttsMerchantLead(stts: number) {
    let status;
    // eslint-disable-next-line default-case
    switch (stts) {
      case 0: status = 'New';
        break;
      case 1: status = 'Active';
        break;
      case 2: status = 'Potential';
        break;
      case 3: status = 'Uncomplete';
        break;
      case 4: status = 'Underwriting';
        break;
      case 5: status = 'Close';
        break;
      case 6: status = 'Temporary';
        break;
      default: status = 'Potential';
    }
    return status;
  }

  async getInvoice(params: ReportParams, page = 1, isExport: boolean) {
    try {
      this.loading = true;
      const name = params.merchant ? params.merchant.merchant_name : undefined;
      const merchant = params.merchant ? params.merchant.merchant_code : undefined;
      const brand = params.brand ? params.brand.merchant_brand : undefined;
      const year = params.year && params.year.value !== '0' ? params.year.value : 0;
      const month = params.month && params.month.value !== '0' ? params.month.value : 0;
      const status = params.status && params.status.value !== '' ? params.status.value : undefined;
      const service = params.service && params.service.service_code !== 'All'
        ? params.service.service_dbname : undefined;

      const transactionDate = {
        startDate: params.transactionDate?.startDate === null ? undefined
          : dayjs(params.transactionDate?.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.transactionDate?.endDate === null ? undefined
          : dayjs(params.transactionDate?.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };

      if (isExport) {
        await apiSandbox.get('/consumer/merchant/lead', {
          params: {
            page,

            merchant_name: name,
            merchant_code: merchant,
            period: year === 0 && month === 0 ? undefined : `${year}-${month}`,
            merchant_lead_status: status,
            service,
            start_register_date: transactionDate.startDate,
            end_register_date: transactionDate.endDate,
            brand,
            export: true,
          },
          responseType: 'arraybuffer',
        }).then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data]),
          );
          let filename = '';
          const disposition = response.headers['content-disposition'];
          if (disposition && disposition.indexOf('attachment') !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename || 'MerchantLead.xlsx');
          document.body.appendChild(link);
          link.click();
        });
      } else {
        const { data } = await apiSandbox.get<MerchantsMResponse>('/consumer/merchant/lead', {
          params: {
            page,

            merchant_name: name,
            merchant_code: merchant,
            period: year === 0 && month === 0 ? undefined : `${year}-${month}`,
            merchant_lead_status: status,
            service,
            start_register_date: transactionDate.startDate,
            end_register_date: transactionDate.endDate,
            brand,
          },
        });

        this.page = page;
        this.merchantsLead = data.data;
        this.totalPage = Math.ceil(data.total / data.per_page);
        this.from = data.from;
        this.to = data.to;
        this.totalItem = data.total;
        this.loading = false;
      }
      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  // dateFormat(time: string) {
  //   const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
  //   if (formatted === 'Invalid Date') {
  //     return '-';
  //   }

  //   return formatted;
  // }

  // eslint-disable-next-line class-methods-use-this
  // periodFormat(time: string) {
  //   const formatted = dayjs(time, 'MM-YYYY').format('MMMM YYYY');
  //   if (formatted === 'Invalid Date') {
  //     return '-';
  //   }

  //   return formatted;
  // }
}
